import React from "react";
import { TableBox } from "./style";

const Header = () => null;
Header.displayName = "Header";
const Body = () => null;
Body.displayName = "Body";
const Foot = () => null;
Foot.displayName = "Foot";
const Row = () => null;
Row.displayName = "Row";
const HeaderCell = () => null;
HeaderCell.displayName = "HeaderCell";
const Cell = () => null;
Cell.displayName = "Cell";

const subComponentHandler = (children, component) => {
  const result = [];
  const type = [component.displayName] || [component.name];
  React.Children.forEach(children, child => {
    const childType =
      child && child.type && (child.type.displayName || child.type.name);
    if (type.includes(childType)) {
      result.push(child);
    }
  });
  return result;
};

class Table extends React.Component {
  renderHeader() {
    const { children } = this.props;
    const result = subComponentHandler(children, Header);
    if (result.length <= 0) {
      return null;
    }
    return result.map((item, i) => {
      return (
        <thead {...item.props} className={item.props.className} key={i}>
          {this.renderRow(item.props)}
        </thead>
      );
    });
  }
  renderBody() {
    const { children } = this.props;
    const result = subComponentHandler(children, Body);
    if (result.length <= 0) {
      return null;
    }
    return result.map((item, i) => {
      return (
        <tbody {...item.props} className={item.props.className} key={i}>
          {this.renderRow(item.props)}
        </tbody>
      );
    });
  }
  renderFoot() {
    const { children } = this.props;
    const result = subComponentHandler(children, Foot);
    if (result.length <= 0) {
      return null;
    }
    return result.map((item, i) => {
      return (
        <tfoot {...item.props} className={item.props.className} key={i}>
          {this.renderRow(item.props)}
        </tfoot>
      );
    });
  }
  renderRow(props) {
    const { children } = props;

    const result = subComponentHandler(children, Row);
    if (result.length <= 0) {
      return null;
    }
    return result.map((item, i) => {
      return (
        <tr key={i} {...item.props}>
          {this.renderHeaderCell(item.props)}
          {this.renderCell(item.props)}
        </tr>
      );
    });
  }
  renderHeaderCell(props) {
    const { children } = props;
    const result = subComponentHandler(children, HeaderCell);
    if (!result[0]) {
      return null;
    }
    return result.map((item, i) => (
      <th {...item.props} className={item.props.className} key={i}>
        {item.props.children}
      </th>
    ));
  }
  renderCell(props) {
    const { children } = props;
    const result = subComponentHandler(children, Cell);
    if (!result[0]) {
      return null;
    }
    return result.map((item, i) => (
      <td {...item.props} className={`${item.props.className} ${item.props.pricetype || ""}`} key={i} colSpan={item.props.colSpan}>
        {item.props.children}
      </td>
    ));
  }
  render() {
    return (
      <TableBox>
        {this.renderHeader()}
        {this.renderBody()}
        {this.renderFoot()}
      </TableBox>
    );
  }
}
Table.Header = Header;
Table.Body = Body;
Table.Foot = Foot;
Table.Row = Row;
Table.HeaderCell = HeaderCell;
Table.Cell = Cell;
export default Table;
